import React, { useEffect, useState } from 'react';
import { hitApi } from '../utils/apiCall';

const SelectRoleForTeacher = ({ setRolefromComp }) => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(() => {
    const saved = localStorage.getItem("role");
    return saved || null;
  });

  useEffect(() => {
    fetchRoleData();
  }, []);

  const fetchRoleData = async () => {
    const fd = new FormData();
    fd.append("centerBranch", localStorage.getItem('branch_id'));
    const result = await hitApi('settings/roleCurl', 'getRolesDetails', fd);

    console.log("role", result)
    if (result.success && Array.isArray(result.data)) {
      setRoles(result.data);
    }
  };

  const handleSelect = (roleId) => {
    setSelectedRole(roleId);
    localStorage.setItem("role", JSON.stringify({ [roleId]: true }));
    setRolefromComp({ [roleId]: true });
  };

  return (
    <div className="container">
     
      <div className="row">
        {roles.map((role) => (
          <div className="col-6 mb-3" key={role.id}>
            <div
              className="p-2 rounded shadow-sm border text-center"
              style={{
                cursor: "pointer",
                backgroundColor: selectedRole == role.id ? "#CFE2FF" : "#fff",
                transition: "background-color 0.3s",
                fontWeight: selectedRole == role.id ? "bold" : "normal",
              }}
              onClick={() => handleSelect(role.id)}
            >
              {role.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectRoleForTeacher;
